import type { FormDSL } from '@commenda/types';
import { walkComponents } from '../dsl-traversal';

export interface KeyPersonsData {
  fieldId: string;
  keyId: string;
  mode: 'select-add' | 'view-edit';
  selectedIds: string[];
  entries: Record<string, Record<string, unknown>>;
}

/**
 * Extract KeyPersons component data from the form DSL. The integration hook
 * later populates `selectedIds` and `entries` from formData; the extractor
 * only seeds the static config (keyId + mode) read from `component.props`.
 */
export function extractKeyPersonsComponents(dsl: FormDSL): KeyPersonsData[] {
  const components: KeyPersonsData[] = [];
  walkComponents(dsl, (component) => {
    if (component.component === 'KeyPersons' && component.fieldId) {
      const props = component.props as
        | {
            keyId?: string;
            mode?: 'select-add' | 'view-edit';
          }
        | undefined;
      components.push({
        fieldId: component.fieldId,
        keyId: props?.keyId || '',
        mode: props?.mode ?? 'select-add',
        selectedIds: [],
        entries: {},
      });
    }
  });
  return components;
}
